import { OlMapBaseComponent } from "gmap";
import { SortHelper } from "shtools";
import { Site } from "solar-bo";
import * as ol from 'ol';

export class TooltipSite {

    mapTooltip; //document.getElementById('tooltip');
    mapTooltipOverlay;
    mapc: OlMapBaseComponent
    constructor(olMapBaseComponent: OlMapBaseComponent){
        this.configToolTip(olMapBaseComponent);
    }
    configToolTip(olMapBaseComponent: OlMapBaseComponent) {
        this.mapc=olMapBaseComponent;
      try {
        this.mapTooltip = document.getElementById('mapTooltip');
        this.mapTooltipOverlay = new ol.Overlay({
          element: this.mapTooltip,
          offset: [14, 0]
          //,positioning: 'bottom-left'
  
        });
  
        let map = olMapBaseComponent.map;
        map.addOverlay(this.mapTooltipOverlay);
        map.on('pointermove', this.displayTooltip.bind(this));
      }
      catch (e) {
        console.error(e);
      }
  
    }

    displayTooltip(evt) {
        let pixel = evt.pixel;
        let map = this.mapc.map;
        let feature = map.forEachFeatureAtPixel(pixel, function (feature) {
          return feature;
        });
    
        if (feature) {
          let features = feature.get('features');
          let size = 0;
    
    
          if (features == undefined) {
            size = 1;
          } else if (features instanceof Array) {
            size = features.length;
          }
    
          let desc = "";
          let objId = "";
          if (size == 1) {
            if (features instanceof Array) {
              desc = features[0].frlayerinfo.name
              objId = features[0].frlayerinfo.id;
            }
    
          } else {
            let siteList: Site[] = (features as Array<any>).map(item => item.frlayerinfo.refObject);
            siteList.sort((a, b) => SortHelper.sortByStringLocale(a.name, b.name));
            let x = 1;
            for (let site of siteList) {
              desc += site.name + "<br> ";
              x++;
              if (x == 15) {
                desc += " and more.";
                break;
              }
            }
          }
    
    
    
          //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip feat ",feature);
          //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip fr ",fr);
          if (desc) {
            // DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"displayTooltip11",feature);
            this.mapTooltipOverlay.setPosition(evt.coordinate);
            this.mapTooltip.innerHTML = desc;
            this.mapTooltip.style.display = 'block';
          }
    
        }
        else {
          this.mapTooltip.style.display = 'none';
        }
      };


}